// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"964ee37e","479":"7162792b","485":"871cd310","531":"fa606321","915":"8fdb49b3","949":"fa1854da"}[chunkId] + ".chunk.js";
};